import axios from "axios";
import { createApiError } from "./errorUtils";

const API_URL = process.env.REACT_APP_API_URL;

// Cria um novo produto
export function criarProduto(produtoData) {
  return axios.post(`${API_URL}/produtos`, produtoData).catch((error) => {
    throw createApiError(error, "Erro ao criar produto.");
  });
}

// Busca todos os produtos da loja do usuário
export function getProdutos(lojaId) {
  return axios.get(`${API_URL}/produtos`, { params: { lojaId } }).catch((error) => {
    throw createApiError(error, "Erro ao buscar produtos.");
  });
}

export function getProdutosPaginado(
  lojaId,
  {
    page = 1,
    limit = 30,
    search = "",
    sortOrder = "newest",
    status = "ativos",
  } = {}
) {
  return axios
    .get(`${API_URL}/produtos`, {
      params: { lojaId, page, limit, search, sortOrder, status },
    })
    .catch((error) => {
      throw createApiError(error, "Erro ao buscar produtos.");
    });
}

// Busca um único produto pelo ID
export function getProdutoById(produtoId, lojaId) {
  return axios
    .get(`${API_URL}/produtos/${produtoId}`, { params: { lojaId } })
    .catch((error) => {
      throw createApiError(error, "Erro ao buscar produto.");
    });
}

// Atualiza um produto existente
export function atualizarProduto(produtoId, produtoData) {
  return axios.put(`${API_URL}/produtos/${produtoId}`, produtoData).catch((error) => {
    throw createApiError(error, "Erro ao atualizar produto.");
  });
}

// Deleta um produto
export function deletarProduto(produtoId, lojaId) {
  return axios
    .delete(`${API_URL}/produtos/${produtoId}`, { params: { lojaId } })
    .catch((error) => {
      throw createApiError(error, "Erro ao deletar produto.");
    });
}

// Busca todas as tags disponíveis
export function getTags() {
  return axios.get(`${API_URL}/tags`).catch((error) => {
    throw createApiError(error, "Erro ao buscar tags.");
  });
}

// Cria novas tags
export function criarTags(tags) {
  return axios.post(`${API_URL}/tags`, { tags }).catch((error) => {
    throw createApiError(error, "Erro ao criar novas tags.");
  });
}

export function atualizarTag(tagId, novoNome) {
  return axios.put(`${API_URL}/tags/${tagId}`, { novoNome }).catch((error) => {
    throw createApiError(error, "Erro ao atualizar a tag.");
  });
}

// Deleta uma tag
export function deletarTag(tagId) {
  return axios.delete(`${API_URL}/tags/${tagId}`).catch((error) => {
    throw createApiError(error, "Erro ao deletar a tag.");
  });
}

// Busca produtos por uma tag específica
export function getProdutosPorTag(tagNome) {
  return axios.get(`${API_URL}/tags/${tagNome}`).catch((error) => {
    throw createApiError(error, "Erro ao buscar produtos pela tag.");
  });
}

export function getDetalhesTag(tagId) {
  return axios.get(`${API_URL}/tags/id/${tagId}/produtos`).catch((error) => {
    throw createApiError(error, "Erro ao buscar detalhes da tag.");
  });
}

export function removerTagDeProdutos(tagId, produtoIds) {
  return axios
    .post(`${API_URL}/tags/${tagId}/remover-produtos`, { produtoIds })
    .catch((error) => {
      throw createApiError(error, "Erro ao remover tag dos produtos.");
    });
}
